import { getCompanyNameByOrganization, StringManager } from '@payments-checkout/shared/helpers/index';
import { Link, Text } from '@stone-payments/jade';
import { HeadingWrapper } from './style';

type CheckoutHeadingProps = {
  accountName?: string;
  displayName?: string;
  organization?: string;
  email?: string;
  url?: string;
  cnpj?: string;
};

export function CheckoutHeading({
  accountName,
  displayName,
  organization,
  email,
  url,
  cnpj,
}: CheckoutHeadingProps) {

  const name = getCompanyNameByOrganization({ organization, accountName, displayName });
  const title = name ? `vendido por` : 'Checkout';
  const formattedCnpj = cnpj && StringManager.formatCnpj(cnpj);

  return (
    <HeadingWrapper className="mb-jade-200 gap-jade-100" data-testid="checkout-heading">
      <Text variant="overline" color="medium" as="h1">
        {title}
      </Text>
      <div className="flex flex-col gap-jade-50">
        <Text variant="heading-small" as="h2">
          {name}
        </Text>
        {
          !!formattedCnpj && (
            <Text variant="text-medium" weight="regular">
              {formattedCnpj}
            </Text>)
        }
      </div>
      {
        (!!email || !!url) && (
          <div className='flex gap-jade-200'>
            {url && <Link icon="link" trailing='none' className='[&_span::after]:hidden' href={url}>Site</Link>}
            {email && <Link icon="mail" trailing='none' className='[&_span::after]:hidden' href={`mailto:${email}`}>{email}</Link>}
          </div>)}
    </HeadingWrapper>
  );
}
